// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__M8VWl","whoops":"NotFound_whoops__3tg_K","nothing":"NotFound_nothing__UKVGJ","humor":"NotFound_humor__ZVzBn"};